var map = {
	"./market0-0.json": 1251,
	"./market1-0.json": 1252,
	"./market10-0.json": 1253,
	"./market11-0.json": 1254,
	"./market12-0.json": 1255,
	"./market13-0.json": 1256,
	"./market14-0.json": 1257,
	"./market15-0.json": 1258,
	"./market16-0.json": 1259,
	"./market17-0.json": 1260,
	"./market18-0.json": 1261,
	"./market2-0.json": 1262,
	"./market27-0.json": 1263,
	"./market3-0.json": 1264,
	"./market4-0.json": 1265,
	"./market5-0.json": 1266,
	"./market6-0.json": 1267,
	"./market7-0.json": 1268,
	"./market8-0.json": 1269,
	"./market9-0.json": 1270
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1250;


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market ^\.\/market.*\-0\.json$
// module id = 1250
// module chunks = 3